import styled, { css } from 'styled-components'

export const Header = styled.div`
  ${({
    theme: {
      app: { headerGradient },
    },
  }) => css`
    background: ${headerGradient};
    font-size: 20px;
    color: #fff;
    font-weight: 700;
    letter-spacing: 0.15px;
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.18);
    padding: 18px 24px;
    position: relative;

    ::after {
      content: '';
      position: absolute;
      inset: auto 0 0;
      height: 1px;
      background: linear-gradient(90deg, transparent, rgba(120, 244, 229, 0.55), transparent);
    }
  `}
`

export const ButtonWrapper = styled.div`
  padding: 20px;
  display: flex;
  justify-content: flex-end;

  > :not(:last-child) {
    margin-right: 10px;
  }
`
